import { render, staticRenderFns } from "./BillingVirtualAccountMandiri.vue?vue&type=template&id=5752d1aa"
import script from "./BillingVirtualAccountMandiri.vue?vue&type=script&lang=js"
export * from "./BillingVirtualAccountMandiri.vue?vue&type=script&lang=js"
import style0 from "./BillingVirtualAccountMandiri.vue?vue&type=style&index=0&id=5752d1aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports